import Loadable from '../../components/loadable';

const ManageWebsitePromotions = Loadable({
  loader: () => import('../../pages/manage_website/promotions'),
});

angular.module('gym').value('ManageWebsitePromotions', ManageWebsitePromotions);
